/** @format */

"use client"; //this is a client side component

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import ApiInstance from "./instance";

const initialState = {
    isOrderLoading: false,
    isProductLoading: false,
    isCouponLoading: false,
    couponDetails: null,
    productError: null,
    orderError: null,
    productInfo: null,
    orderStatus: null,
    couponError: null,

};

export const checkoutSlice = createSlice({
    name: "checkout",
    initialState,
    reducers: {
        removeCoupon: (state, action) => {
            state.couponDetails = null;
        },
        removeProduct: (state, action) => {
            state.productInfo = null;

        }

    },
    extraReducers: (builder) => {
        builder.addCase(getProductsInfo.pending, (state, action) => {
            state.isProductLoading = true;
        });
        builder.addCase(getProductsInfo.fulfilled, (state, action) => {
            state.productInfo = action.payload?.data ? action.payload?.data : [];
            state.isProductLoading = false;
        });
        builder.addCase(getProductsInfo.rejected, (state, action) => {
            state.productError = action.payload;
            state.isProductLoading = false;
        });
        builder.addCase(createOrder.pending, (state, action) => {
            state.isOrderLoading = true;
        });
        builder.addCase(createOrder.fulfilled, (state, action) => {
            state.isOrderLoading = false;
            state.orderStatus = action.payload;
        });
        builder.addCase(createOrder.rejected, (state, action) => {
            state.isOrderLoading = false;

            state.orderError = action.payload;
        });
        builder.addCase(applyCoupon.pending, (state, action) => {
            state.isCouponLoading = true;
        });
        builder.addCase(applyCoupon.fulfilled, (state, action) => {
            state.isCouponLoading = false;
            state.couponDetails = action.payload;
        });
        builder.addCase(applyCoupon.rejected, (state, action) => {
            state.isCouponLoading = false;
            state.couponError = action.payload;
        });

    },
});



export const getProductsInfo = createAsyncThunk("products//getProductsInfo", async (data, thunkAPI) => {
    return ApiInstance("get-products", "post", data, thunkAPI);
});
export const createOrder = createAsyncThunk("orders//createOrder", async (data, thunkAPI) => {
    console.log(data, "data")
    return ApiInstance("order", "post", data, thunkAPI);
});
export const applyCoupon = createAsyncThunk("Coupon//applyCoupon", async (data, thunkAPI) => {
    const formdata = new FormData();
    for (const [key, value] of Object.entries(data)) {
        formdata.append(key, value);
    }
    return ApiInstance("get-coupon", "post", formdata, thunkAPI);
});
export const { removeCoupon, removeProduct } = checkoutSlice.actions;

export default checkoutSlice.reducer;
